import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TBaseRequest } from '~/store/types.ts';
import { TResponsiblePersons } from '~/modules/remote-banking-contacts/type.ts';
import { TResponsiblePersonsInfo } from '~/store/remote-banking-contacts/types.ts';

export const responsiblePersonsAccountManagers = createAsyncThunk<null, TBaseRequest>(
  'remoteBankingContacts/accountManagers',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.post(
        `/remote-banking-contacts/applications/${applicationId}/account-managers`,
        null,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const responsiblePersons = createAsyncThunk<TResponsiblePersons, TBaseRequest>(
  'remoteBankingContacts/responsiblePersons',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.get(
        `/remote-banking-contacts/applications/${applicationId}/persons`,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const responsiblePersonsInformation = createAsyncThunk<
  TResponsiblePersonsInfo,
  TBaseRequest
>(
  'remoteBankingContacts/responsiblePersonsInformation',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.get(`/remote-banking-contacts/applications/${applicationId}`, {
        headers,
      });

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
